var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9EC75E3F-47C5-4F5B-8F21-5D6B11E5B339@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.97862279,2.89022827 C4.35248666,0.112810637 8.27043451,-0.772397886 11.6077966,0.714643755 C11.9861509,0.883228607 12.1562027,1.32661044 11.9876179,1.70496481 C11.819033,2.08331917 11.3756512,2.25337095 10.9972968,2.0847861 C8.26672786,0.868115668 5.06113416,1.59237719 3.11888191,3.8648098 C1.17662965,6.13724241 0.960395546,9.41651497 2.58744151,11.9243059 C4.21448747,14.4320968 7.29722416,15.5710086 10.1639097,14.7234193 C13.0305952,13.8758299 14.9983376,11.2436491 15.0000467,8.25471493 L15.0000467,7.55721493 C15.0000467,7.14300137 15.3358331,6.80721493 15.7500467,6.80721493 C16.1642603,6.80721493 16.5000467,7.14300137 16.5000467,7.55721493 L16.5000467,8.25514375 C16.4979575,11.9088096 14.0929391,15.1259195 10.5892123,16.1618621 C7.08548554,17.1978046 3.31769626,15.8058013 1.32908453,12.7407235 C-0.659527205,9.67564571 -0.395241078,5.66764591 1.97862279,2.89022827 Z M15.9697166,0.974384842 C16.2626098,0.681491623 16.7374836,0.681491623 17.0303768,0.974384842 C17.32327,1.26727806 17.32327,1.7421518 17.0303768,2.03504501 L8.78037679,10.285045 C8.48748357,10.5779382 8.01260984,10.5779382 7.71971662,10.285045 L5.46971662,8.03504501 C5.1768234,7.7421518 5.1768234,7.26727806 5.46971662,6.97438484 C5.76260984,6.68149162 6.23748357,6.68149162 6.53037679,6.97438484 L8.2500467,8.69405476 Z",
    id: "path-1-check-circle"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_interactions",
    transform: "translate(-171.000000, -838.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(139.000000, 553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(12.757058, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 190.741176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/user",
    transform: "translate(19.242942, 59.008824)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "FFF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-check-circle"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "FFF",
    xlinkHref: "#path-1-check-circle"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.a3475a10bf2ea941de99b2775e17126a.svg";
export { ForwardRef as ReactComponent };